import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class Group extends BaseAdapter {
  namespace = 'groups/v4';
  modelNamePlural = 'groups';
}
